import React from 'react';
import { exportEventName } from '.';
import useChartReflow from '../../../../hooks/generic/charts/useChartReflow';
import i18n from '../../../../utils/ChrI18n';
import { isPresent } from '../../../../utils/CoreExtensions/ArrayExtensions';
import { safeMutate } from '../../../../utils/GeneralUtils';
import ChrLink from '../../../generic/Utils/ChrLink';
import { MetricUId } from '../../Metrics/constants';
import { getMetricDataFromArray } from '../../Metrics/utils';
import ChrComparison from '../../Reports/templates/ChrComparison';
import PieChart from '../../Reports/templates/PieChart';
import MetricCard from '../MetricCard';
import WidgetBodyWrapper from '../WidgetBodyWrapper';
import getChartConfig, { chartOnlyMetrics } from './utils';


// TODO_ADMIN_DASHBOARD_SELF_MATCH : To open dashboard for mentee req admin scenario as well; Check widgets once
const Body = (props) => {
  const { metrics, name } = props;
  const numericMetrics = metrics.filter(metric => !chartOnlyMetrics.includes(metric.uId));
  const propsForNumericMetrics = safeMutate(props, draftProps => {
    draftProps.metrics = numericMetrics;
  });
  const { chartWrapperReference, chartCallbackFunction } = useChartReflow();
  const isSplitWidget = isPresent(numericMetrics);
  const cardMetric = getMetricDataFromArray(metrics, MetricUId.PENDING_MENTORING_REQUESTS);
  const cardActionRequired = cardMetric.data.value > 0;
  const previousPeriod = cardMetric.data.previousPeriod;
  const totalMentoringRequests = getMetricDataFromArray(metrics, MetricUId.TOTAL_MENTORING_REQUESTS);
  const childClass = `col-12 col-md-6 ${!isSplitWidget && "mx-auto"} dynamic-grid-item-child`;

  return (
    <div className="d-flex flex-column custom-max-height-550-px p-3 overflow-auto">
      {
        cardMetric.actionNeededByAdmin &&
        <div>
          <MetricCard
            value={ cardMetric.data.value }
            title={ cardMetric.longName }
            result={ cardActionRequired && i18n.t("metrics.metric_card.take_action") }
            url={ cardMetric.url }
            alert={ cardMetric.data.alert }
            resultUrl={ cardActionRequired && cardMetric.url }
            eventDetails={ cardMetric.eventDetails }
            subtitle={ previousPeriod && <ChrComparison
              changeSentiment={ previousPeriod.insights.sentiment }
              changeValue={ previousPeriod.insights.changeValue }
              changeDirection={ previousPeriod.insights.direction }
              periodOne={ { dateRangeStr: previousPeriod.comparedAgainstPeriod.dateRangeStr, presetStr: previousPeriod.comparedAgainstPeriod.presetStr, value: cardMetric.data.value } }
              periodTwo={ { dateRangeStr: previousPeriod.timePeriod.dateRangeStr, presetStr: previousPeriod.timePeriod.presetStr, value: previousPeriod.value } }
            /> }
          />
        </div>
      }
      <div className='row no-gutters' ref={ chartWrapperReference }>
        <div className={ `cui-widget-pie-chart ${childClass}` }>
          <PieChart
            chartOptions={ getChartConfig({ metrics, name }) }
            configs={ { export: true, exportEventName } }
            callbackFn={ chartCallbackFunction }
          />
        </div>
        { isSplitWidget &&
          <div className={childClass}>
            <WidgetBodyWrapper { ...propsForNumericMetrics } wrapperPadding="py-3" />
          </div>
        }
      </div>
      {
        totalMentoringRequests.expiryDetails &&
        <div className='cui-widget-info-bg d-flex flex-gap-10 p-3 border-radius-0-25 font-bold'>
          <i className="fa-regular fa-gear mt-1" />
          <span>{ totalMentoringRequests.expiryDetails.infoText }</span>
          <ChrLink newTab href={ totalMentoringRequests.expiryDetails.url }>({ i18n.t("display_string.Change") })</ChrLink>
        </div>
      }
    </div>
  );
};

export default Body;
